import api from "../../domain/api";
import {
  GET_SERVICEPACKAGES_STATED,
  GET_SERVICEPACKAGES,
  GET_SERVICEPACKAGES_ENDED,
  ADD_SERVICEPACKAGE_STATED,
  ADD_SERVICEPACKAGE,
  ADD_SERVICEPACKAGE_ENDED,
  EDIT_SERVICEPACKAGE_STATED,
  EDIT_SERVICEPACKAGE,
  EDIT_SERVICEPACKAGE_ENDED,
  GET_SERVICEPACKAGE_STATED,
  GET_SERVICEPACKAGE,
  GET_SERVICEPACKAGE_ENDED,
  GET_ALL_SERVICEPACKAGES_STATED,
  GET_ALL_SERVICEPACKAGES,
  GET_ALL_SERVICEPACKAGES_ENDED,
} from "../types/servicepackage_type";
import * as qs from "qs";
import { handleError } from "../../shared/handleError";
import { setAlert } from "./alert";

export const addServicepackage = (formData) => async (dispatch, getState) => {
  try {
    dispatch({
      type: ADD_SERVICEPACKAGE_STATED,
    });
    const { data } = await api.post(`/servicepackages`, formData);
    dispatch({
      type: ADD_SERVICEPACKAGE,
      payload: data,
    });
    dispatch({
      type: ADD_SERVICEPACKAGE_ENDED,
    });
  } catch (error) {
    dispatch({
      type: ADD_SERVICEPACKAGE_ENDED,
    });
    dispatch(handleErrorLocal(error));
    dispatch(handleError(error));
  }
};
export const getServicepackages =
  ({ pageNumber = ""}) =>
  async (dispatch) => {
    try {
      dispatch({
        type: GET_SERVICEPACKAGES_STATED,
      });
      const queryParams = qs.parse(window.location.search.replace("?", ""));
      const query = qs.stringify(queryParams, {
        encodeValuesOnly: true, // prettify url
      });

      const { data } = await api.get(
        `/servicepackages?&pageNumber=${pageNumber}&${query}`
      );

      dispatch({
        type: GET_SERVICEPACKAGES,
        payload: data,
      });
      dispatch({
        type: GET_SERVICEPACKAGES_ENDED,
      });
    } catch (error) {
      dispatch({
        type: GET_SERVICEPACKAGES_ENDED,
      });
      dispatch(handleErrorLocal(error));
      dispatch(handleError(error));
    }
  };
export const getServicepackage = (id) => async (dispatch) => {
  try {
    dispatch({
      type: GET_SERVICEPACKAGE_STATED,
    });
    const { data } = await api.get(`/servicepackages/${id}`);

    dispatch({
      type: GET_SERVICEPACKAGE,
      payload: data,
    });
    dispatch({
      type: GET_SERVICEPACKAGE_ENDED,
    });
  } catch (error) {
    dispatch({
      type: GET_SERVICEPACKAGE_STATED,
    });
    dispatch(handleErrorLocal(error));
    dispatch(handleError(error));
  }
};
export const editServicepackage = (id, formData) => async (dispatch) => {
  try {
    dispatch({
      type: EDIT_SERVICEPACKAGE_STATED,
    });
    const { data } = await api.put(`/servicepackages/${id}`, formData);
    dispatch({
      type: EDIT_SERVICEPACKAGE,
      payload: data,
    });
    dispatch({
      type: EDIT_SERVICEPACKAGE_ENDED,
    });
  } catch (error) {
    dispatch({
      type: EDIT_SERVICEPACKAGE_ENDED,
    });
    dispatch(handleErrorLocal(error));
    dispatch(handleError(error));
  }
};
export const deleteServicepackage = (id) => async (dispatch) => {
  try {
    const { data } = await api.delete(`/servicepackages/${id}`);
    dispatch(setAlert("Servicepackage Deleted Successfully", "success"));
  } catch (error) {
    dispatch(handleErrorLocal(error));
    dispatch(handleError(error));
  }
};
export const getAllServicepackages = ({ term, value }) => async (dispatch) => {
  try {
    dispatch({
      type: GET_ALL_SERVICEPACKAGES_STATED,
    });
    const { data } = await api.get(`/servicepackages/all?term=${term}&value=${value}`);

    dispatch({
      type: GET_ALL_SERVICEPACKAGES,
      payload: data,
    });
    dispatch({
      type: GET_ALL_SERVICEPACKAGES_ENDED,
    });
  } catch (error) {
    dispatch({
      type: GET_ALL_SERVICEPACKAGES_ENDED,
    });
    dispatch(handleErrorLocal(error));
    dispatch(handleError(error));
  }
};

export const handleErrorLocal = () => async (dispatch) => {};
